import { useEffect } from "react";

const useShowAnnouncement = (setShowAnnouncement: any, userInfo: any, loggedIn: any): void => {
  useEffect(() => {
    if (!loggedIn && sessionStorage.getItem("hideAnnouncement")) setShowAnnouncement(false);
    else if (loggedIn && !userInfo?.showAnnouncement) {
      setShowAnnouncement(false);
    } else if (loggedIn && userInfo?.showAnnouncement) {
      setShowAnnouncement(true);
    }
  }, [userInfo, loggedIn, setShowAnnouncement]);
};

export default useShowAnnouncement;
